import { useEffect } from 'react';
import { Container, Row, Col, Card, Modal, Button, Tab, Tabs, Table, Form } from 'react-bootstrap';
import Footer from './components/Footer';
import { useState } from "react";

export default function Programme() {
  useEffect(() => {
    const titles = document.querySelectorAll('.card-title');
    titles.forEach(el => {
      const angle = Math.floor(Math.random() * 360);
      el.style.background = `linear-gradient(${angle}deg, #33A749, #AB1E4A)`;
      
    });
  }, []);

  const [activeModal, setActiveModal] = useState(null);

  const handleClose = () => setActiveModal(null);
  const handleShow = (modalId) => setActiveModal(modalId);

  const programmeSun = [
  { time: '16:00 – 20:00', session: 'Registration' },
  { time: '17:05 – 17:30', session: 'Opening Session' },
  {
    type: 'chairs',
    session: 'Filipa A. Vicente & Marco Rito-Palomares'
  },
  { time: '17:30 – 18:30', session: 'Plenary Lecture — Raquel Aires-Barros' },
  { time: '18:30 – 19:00', session: 'Per-Åke Albertsson Award' },
  { time: '19:00 – 20:30', session: 'Welcome Reception', type: 'special' },
];
  const programmeMon = [
  {
    type: 'topic',
    session: 'DOWNSTREAM PROCESSING'
  },

  { time: '08:00 – 09:00', session: 'Registration' },

  {
    type: 'chairs',
    session: 'James M. Van Alstine & Richard C. Willson'
  },

  { time: '09:00 – 10:00', session: 'Plenary Lecture — John P. Frampton' },
  { time: '10:00 – 10:20', session: 'O1 — Amber Titus' },
  { time: '10:20 – 10:40', session: 'O2 — Marija Kostić' },
  { time: '10:40 – 11:00', session: 'O3 — Elena Kumm' },

  { time: '11:00 – 11:30', session: 'Coffee Break & Project Fair', type: 'break' },

  {
    type: 'chairs',
    session: 'Raquel Aires-Barros & Pardis Saadatmand'
  },

  { time: '11:30 – 12:00', session: 'Keynote Lecture — Stela Jokić' },
  { time: '12:00 – 12:20', session: 'O4 — Ana Miguel Loureiro' },
  { time: '12:20 – 12:40', session: 'O5 — Xristo Zarate' },
  { time: '12:40 – 12:50', session: 'O6 — A. Rita Silva-Santos' },

  { time: '12:50 – 13:50', session: 'Lunch', type: 'break' },
  { time: '13:50 – 14:50', session: 'Poster Session', type: 'special' },

  {
    type: 'chairs',
    session: 'João A. P. Coutinho & Roland Kalb'
  },

  { time: '14:50 – 15:10', session: 'O7 — Sebastião Santos Pereira' },
  { time: '15:10 – 15:30', session: 'O8 — Rok Sekirnik' },
  { time: '15:30 – 15:50', session: 'O9 — Rok Miklavčič' },
  { time: '15:50 – 16:10', session: 'O10 — James M. Van Alstine' },
  { time: '16:10 – 16:30', session: 'O11 — Richard C. Willson' },

  {
    time: '17:00',
    session: 'Trip to Bled Island and Church',
    type: 'special'
  },
];

const programmeTue = [
  { time: '08:00 – 09:00', session: 'Registration' },

  {
    type: 'topic',
    session: 'PROCESS INTEGRATION & OPTIMIZATION'
  },

  {
    type: 'chairs',
    session: 'Valéria de Carvalho Santos-Ebinuma & Edita Jasiukaitytė-Grojzdek'
  },

  { time: '09:00 – 10:00', session: 'Plenary Lecture — Leif Bülow' },
  { time: '10:00 – 10:20', session: 'O12 — Filipe H. B. Sosa' },
  { time: '10:20 – 10:40', session: 'O13 — Maria I. Sousa' },
  { time: '10:40 – 11:00', session: 'O14 — Maria S. M. Mendes' },

  { time: '11:00 – 11:30', session: 'Coffee Break & Project Fair', type: 'break' },

  {
    type: 'chairs',
    session: 'Mónia Martins & Assya Bellaadem'
  },

  { time: '11:30 – 11:50', session: 'O15 — Alma Gómez-Loredo' },
  { time: '11:50 – 12:10', session: 'O16 — Alexandre M. S. Jorge' },
  { time: '12:10 – 12:30', session: 'O17 — Pedro Moleiro' },

  { time: '12:30 – 13:00', session: 'Poster Session', type: 'special' },
  { time: '13:00 – 14:00', session: 'Lunch', type: 'break' },

  {
    type: 'topic',
    session: 'BIOMASS PROCESSING'
  },

  {
    type: 'chairs',
    session: 'Ilja Gasan Osojnik Črnivec & Sari Rautiainen'
  },

  { time: '14:00 – 14:30', session: 'Keynote Lecture — Anna Sandak' },
  { time: '14:30 – 14:50', session: 'O18 — Elif Gökçen Ateş' },
  { time: '14:50 – 15:10', session: 'O19 — Valéria de Carvalho Santos-Ebinuma' },
  { time: '15:10 – 15:30', session: 'O20 — João A. P. Coutinho' },
  { time: '15:30 – 15:50', session: 'O21 — Kamil Urgun' },

  { time: '15:50 – 16:20', session: 'Coffee Break & Project Fair', type: 'break' },

  {
    type: 'chairs',
    session: 'Andrii Kostyniuk & Alexandre M. S. Jorge'
  },

  { time: '16:20 – 16:40', session: 'O22 — Pinar Degirmencioglu' },
  { time: '16:40 – 17:00', session: 'O23 — Joaquim Pinto' },
  { time: '17:00 – 17:20', session: 'O24 — Sari Rautiainen' },
  { time: '17:20 – 17:40', session: 'O25 — Ilja Gasan Osojnik Črnivec' },

  { time: '17:40 – 19:00', session: 'Round Table', type: 'special' },
  { time: '20:00', session: 'Conference Dinner', type: 'special' },
];

const programmeWed = [
  { time: '08:00 – 09:00', session: 'Registration' },

  {
    type: 'topic',
    session: '*SAFE-AND-SUSTAINABLE-BY-DESIGN WORKSHOP — REGULATORY AND SUSTAINABILITY CONSIDERATIONS'
  },

  {
    type: 'chairs',
    session: 'Annamaria Vujanović & Monika Arnič'
  },

  { time: '09:00 – 10:00', session: 'Plenary Lecture — Barry Hardy' },
  { time: '10:00 – 10:20', session: 'O26 — Martin Himly' },
  { time: '10:20 – 10:40', session: 'O27 — Guillermo Ormazabal' },
  { time: '10:40 – 11:00', session: 'O28 — Uroš Novak' },

  { time: '11:00 – 11:30', session: 'Coffee Break & Project Fair', type: 'break' },

  {
    type: 'chairs',
    session: 'Anja Verbič & Filipe H. B. Sosa'
  },

  { time: '11:30 – 11:50', session: 'O29 — Milica Nikolić' },
  { time: '11:50 – 12:10', session: 'O30 — Jan Puhar' },
  { time: '12:10 – 12:30', session: 'O31 — Marcelo Fernandez Lahore' },

  { time: '12:30 – 13:00', session: 'Poster Session', type: 'special' },
  { time: '13:00 – 14:00', session: 'Lunch', type: 'break' },

  {
    type: 'topic',
    session: 'BIOPRODUCTS ENGINEERING FOR BIOPROCESSING ENHANCEMENT'
  },

  {
    type: 'chairs',
    session: 'Brigita Hočevar & Filipa A. Vicente'
  },

  { time: '14:00 – 14:30', session: 'Keynote Lecture — Halil Mecit Öztop' },
  { time: '14:30 – 14:50', session: 'O32 — Marija Lemić' },
  { time: '14:50 – 15:10', session: 'O33 — Daniela B. Silva' },
  { time: '15:10 – 15:30', session: 'O34 — Katja Klun' },

  { time: '15:30 – 15:50', session: 'Coffee Break & Project Fair', type: 'break' },

  {
    type: 'chairs',
    session: 'Dana Marinič & Pinar Degirmencioglu'
  },

  { time: '15:50 – 16:20', session: 'O35 — Ricardo G. Rocha' },
  { time: '16:20 – 16:40', session: 'O36 — Vojtěch Škopek' },
  { time: '16:40 – 17:00', session: 'O37 — Rok Pogorevc' },

  { time: '17:00 – 17:20', session: 'Closing Session', type: 'special' },
];

const [activeKey, setActiveKey] = useState('sunday');

  return (
    <>
    <section id="hero" className="hero hero-background  position-relative">
      <Container >
        <Row className="align-items-center">
            <Col md={8} lg={6} className=''>
              <h1 className="display-3 fw-bold text-white">Programme</h1>
              
            </Col>
          </Row>
      </Container>
    </section>
    
    <section id="programme">
      
      <Container >
        <Row>
          <Col lg={{ span: 8, offset: 2 }} className='pt-5 pb-5'>
            <h2 className='h1 mb-4 purple-h'>Scientific Programme</h2>
            <p>The scientific programme brings together <highlight>a diverse range of topics at the forefront of bioprocessing and bioproduct development.</highlight> It reflects the latest advances in downstream processing, integration and optimization of processes, regulatory and sustainability frameworks, and the engineering of novel bioproducts. Participants will gain insight into state-of-the-art techniques, emerging trends, and innovative approaches that are shaping the future of the field.</p>
            <Button href="files/BPP2026_scientific programme.pdf" target='_blank' variant="outline-bpp-pink" size="md" className='text-white_ mt-2 mb-3'>Download programme (.pdf)</Button>
          </Col>
        </Row>

        <Form.Select
          className="programme-mobile-select mb-3"
          value={activeKey}
          onChange={(e) => setActiveKey(e.target.value)}
        >
          <option value="sunday">Sunday, Sep 6<sup>th</sup></option>
          <option value="monday">Monday, Sep 7<sup>th</sup></option>
          <option value="tuesday">Tuesday, Sep 8<sup>th</sup></option>
          <option value="wednesday">Wednesday, Sep 9<sup>th</sup></option>
        </Form.Select>

        <Tabs activeKey={activeKey}
        onSelect={(key) => setActiveKey(key)}
        id="programme-tabs"
        fill
        className="mb-3 programme-tabs">
          <Tab eventKey="sunday" title="Sunday">
            <Table bordered hover responsive className="programme-table">
              <thead>
                <tr>
                  <th style={{ width: '180px' }}>Time</th>
                  <th>Session</th>
                </tr>
              </thead>
              <tbody>
                {programmeSun.map((item, index) => {
                  if (item.type === 'topic') {
                    return (
                      <tr key={index} className="programme-topic">
                        <td colSpan="2">{item.session}</td>
                      </tr>
                    );
                  }

                  if (item.type === 'chairs') {
                    return (
                      <tr key={index} className="programme-chairs">
                        <td></td>
                        <td>
                          <span>Chairs:</span> {item.session}
                        </td>
                      </tr>
                    );
                  }

                  return (
                    <tr
                      key={index}
                      className={item.type ? `programme-${item.type}` : ''}
                    >
                      <td>{item.time}</td>
                      <td>{item.session}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="monday" title="Monday">
            <Table bordered hover responsive className="programme-table">
              <thead>
                <tr>
                  <th style={{ width: '180px' }}>Time</th>
                  <th>Session</th>
                </tr>
              </thead>
              <tbody>
                {programmeMon.map((item, index) => {
                  if (item.type === 'topic') {
                    return (
                      <tr key={index} className="programme-topic">
                        <td colSpan="2">{item.session}</td>
                      </tr>
                    );
                  }

                  if (item.type === 'chairs') {
                    return (
                      <tr key={index} className="programme-chairs">
                        <td></td>
                        <td>
                          <span>Chairs:</span> {item.session}
                        </td>
                      </tr>
                    );
                  }

                  return (
                    <tr
                      key={index}
                      className={item.type ? `programme-${item.type}` : ''}
                    >
                      <td>{item.time}</td>
                      <td>{item.session}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="tuesday" title="Tuesday">
            <Table bordered hover responsive className="programme-table">
              <thead>
                <tr>
                  <th style={{ width: '180px' }}>Time</th>
                  <th>Session</th>
                </tr>
              </thead>
              <tbody>
                {programmeTue.map((item, index) => {
                  if (item.type === 'topic') {
                    return (
                      <tr key={index} className="programme-topic">
                        <td colSpan="2">{item.session}</td>
                      </tr>
                    );
                  }

                  if (item.type === 'chairs') {
                    return (
                      <tr key={index} className="programme-chairs">
                        <td></td>
                        <td>
                          <span>Chairs:</span> {item.session}
                        </td>
                      </tr>
                    );
                  }

                  return (
                    <tr
                      key={index}
                      className={item.type ? `programme-${item.type}` : ''}
                    >
                      <td>{item.time}</td>
                      <td>{item.session}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="wednesday" title="Wednesday">
            <Table bordered hover responsive className="programme-table">
              <thead>
                <tr>
                  <th style={{ width: '180px' }}>Time</th>
                  <th>Session</th>
                </tr>
              </thead>
              <tbody>
                {programmeWed.map((item, index) => {
                  if (item.type === 'topic') {
                    return (
                      <tr key={index} className="programme-topic">
                        <td colSpan="2">{item.session}</td>
                      </tr>
                    );
                  }

                  if (item.type === 'chairs') {
                    return (
                      <tr key={index} className="programme-chairs">
                        <td></td>
                        <td>
                          <span>Chairs:</span> {item.session}
                        </td>
                      </tr>
                    );
                  }

                  return (
                    <tr
                      key={index}
                      className={item.type ? `programme-${item.type}` : ''}
                    >
                      <td>{item.time}</td>
                      <td>{item.session}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <p className='small'>*Safe-and-Sustainable-by-Design Workshop is organised within the TOXBOX project, with the support of and in synergy with the SSbD4Chem project</p>
          </Tab>
        </Tabs>

        <h5 className='mt-5'>Oral Presentations</h5>
        <p className='small'>Please prepare your presentation for 15–17 minutes, followed by 3–5 minutes for questions and discussion.</p>

        <h5 className='mt-4'>Poster Presentations</h5>
        <p className='small'>Posters should be prepared in A0 format (841 × 1189 mm / 84.1 × 118.9 cm). There is no official BPP2026 poster template, so presenters are welcome to use their own design and layout.</p>
      </Container>
    </section>


    <section id="speakers">
      <Container className='my-5'>
        <Row className="py-5">
          <Col lg={{ span: 8, offset: 2 }} className='mb-4 '>
            <h2 className='h1 mb-4 purple-h'>Invited speakers</h2>
          </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card' onClick={() => handleShow("modalA")}>
                <Card.Img variant="top" src="images/speaker-frampton.jpg" className='img-fluid'/>
                
                <Card.Body className='p-4'>
                  <h5>John P. Frampton</h5>
                </Card.Body>
              </Card>
            </Col>

            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card' onClick={() => handleShow("modalB")}>
                <Card.Img variant="top" src="images/speaker-bullow.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Leif Bülow</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card' onClick={() => handleShow("modalC")}>
                <Card.Img variant="top" src="images/speaker-barros.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Raquel Aires-Barros</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card' onClick={() => handleShow("modalD")}>
                <Card.Img variant="top" src="images/speaker-sandak.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Anna Sandak</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card' onClick={() => handleShow("modalE")}>
                <Card.Img variant="top" src="images/speaker-jokic.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Stela Jokić</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card' onClick={() => handleShow("modalF")}>
                <Card.Img variant="top" src="images/speaker-oztop.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Mecit Öztop</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card' onClick={() => handleShow("modalG")}>
                <Card.Img variant="top" src="images/speaker-hardy.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Barry Hardy</h5>
                </Card.Body>
              </Card>
            </Col>
          </Row>
      </Container>
    </section>


    <section id="content">
      <Container >
        
        <Row className="py-5">
          <Col lg={{ span: 8, offset: 2 }} className='mb-4 '>
            <h2 className='h1 mb-4 purple-h'>Conference Topics</h2>
          </Col>
            <Col md={4} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 '>
                <Card.Title>Downstream Processing</Card.Title>
                <Card.Body className='p-4'>
                  <p className='m-0'>Techniques include aqueous two-phase systems, chromatography, membranes, ligands, precipitation, crystallization, flocculation, etc.	Incorporates molecular and thermodynamic aspects for enhanced separation of bioproducts</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className='mb-4'>
              <Card className='border shadow rounded h-100'>
                <Card.Title>Process Integration and Optimization</Card.Title>
                <Card.Body className='p-4'>
                  <p className='m-0'>Focus on continuous production, high-throughput screening, and automation. Leverages artificial intelligence, neural networks, and multiscale modeling to optimize conditions and efficiency.</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className='mb-4'>
              <Card className='border shadow rounded h-100'>
                <Card.Title>Regulatory and Sustainability Considerations</Card.Title>
                <Card.Body className='p-4'>
                  <p className='m-0'>Addresses regulatory aspects and incorporates sustainability assessments such as life cycle analysis (LCA), social LCA, techno-economic analysis (TEA), and Safe and Sustainable by Design (SSbD) approaches.</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className='mb-4'>
              <Card className='border shadow rounded h-100'>
                <Card.Title>Bioproducts Engineering for Bioprocessing Enhancement</Card.Title>
                <Card.Body className='p-4'>
                  <p className='m-0'>Innovation in value and supply chain creation. Protein engineering. Development of new products. Focus on hydrogels, soft matter applications, and in situ resource utilisation, with circular and green chemistry approaches.</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className='mb-4'>
              <Card className='border shadow rounded h-100'>
                <Card.Title>Biomass processing</Card.Title>
                <Card.Body className='p-4'>
                  <p className='m-0'>Pre-treatment strategies. Enzymatic, microbial and catalytic processing. Conversion technologies. Waste valorisation.</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
      </Container>

      
    </section>

     
      <Footer />



      <Modal show={activeModal !== null} onHide={handleClose} size="lg" scrollable centered>
        <Modal.Header closeButton className='px-4'>
          <Modal.Title >
            {activeModal === "modalA" && "John P. Frampton"}
            {activeModal === "modalB" && "Leif Bülow"}
            {activeModal === "modalC" && "Raquel Aires-Barros"}
            {activeModal === "modalD" && "Anna Sandak"}
            {activeModal === "modalE" && "Stela Jokić"}
            {activeModal === "modalF" && "Mecit Öztop"}
            {activeModal === "modalG" && "Barry Hardy"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className='p-4'>
          {activeModal === "modalA" && (
            <>
              <p>
                John P. Frampton obtained his PhD from the State University of New York at Albany in 2009 before completing a postdoctoral fellowship at University of Michigan in 2014. From 2014 to 2024, he held the Tier II Canada Research Chair in Cell, Biomaterial and Matrix Interaction in the School of Biomedical Engineering at Dalhousie University. He leads an interdisciplinary team working at the intersection of materials science, cell biology and clinical research to design next-generation technologies for: 1. understanding fundamental biological processes; 2. understanding how diseases work and improving diagnosis; and 3. developing therapies using advanced natural and synthetic materials. The Frampton Lab is engaged in numerous collaborative projects across academic disciplines, e.g., with neurobiologists to develop materials for repairing spinal cord and peripheral nerve damage, with immunologists to examine the role of immune cells in asthma and other respiratory diseases using living tissue models grown in the lab, and with physicists and chemists to understand the fundamental properties of soft materials such as gels, fibers, and emulsions. The Frampton Lab is also engaged in several industry collaborations to develop new bio-inks for 3D bioprinting and materials for the repair of acute and chronic wounds. In addition to his academic work, Dr. Frampton is CSO of 3D BioFibR Inc., an advanced materials manufacturing company that spun off from his laboratory in 2020.
              </p>

              <div className="mt-4">
                <Button
                  variant="bpp-pink"
                  size="md"
                  href="/files/Frampton_John_plenary.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download Abstract (.pdf)
                </Button>
              </div>
            </>
          )}
          
          {activeModal === "modalB" && (
            <>
              <p>
                Leif Bülow obtained his academic training in several laboratories in Sweden, Netherlands, Switzerland, France and USA.  He has been the main supervisor of 35 completed PhDs, co-supervisor of 14 PhDs. LB has been visiting Professor in plant biotechnology, Jules Verne University, France and guest professor, Swedish Agricultural University. He was awarded the title Honory Doctor in Medical Technology at Mahidol University, Bangkok in 2006. He has held several managing roles in academia and industry including chairman of the Vinnova Excellence Center Center for Bioseparation, Director of  PlantLink (www.plantlink.se), National chairman for the HSV evaluation in Biotechnology, Environmental science and Chemical engineering, Global president of “Blood Substitutes and Oxygen Therapy”, an international organization including academia, industry and regular authorities (e.g. FDA) to promote knowledge and information about alternatives to regular blood. In 2016, he acted as Chairman of the Biotech evaluation of UTC, Compiegne, France, together with the High Council for the Evaluation of Research and Higher Education” (HCERES). Between 2018 and 2023, LB acted as Chairman of Department of Chemistry, Lund University. Since 2017, he serves as Managing Director of ScanOats (www.scanoats.se), an Industrial Research Center focusing on oats.
              </p>

              <div className="mt-4">
                <Button
                  variant="bpp-pink"
                  size="md"
                  href="/files/Bulow_Leif_plenary.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download Abstract (.pdf)
                </Button>
              </div>
            </>
          )}
          
          {activeModal === "modalC" && (
            <>
              <p>
                Raquel Aires-Barros graduated in Chemical Engineering at Instituto Superior Técnico (IST), where she also earned a Master’s in Biotechnology and a PhD in Chemical Engineering. She conducted research at the Massachusetts Institute of Technology (MIT) before joining IST, where she progressed to Full Professor in the Department of Bioengineering. She is also Senior Researcher at the Institute for Bioengineering and Biosciences (IBB), leading the Bioprocess Engineering group. She has held several senior academic leadership roles at IST, including President of the Pedagogical Council, Vice-President of the Scientific Council, and Vice-President of the School Board. Since 2022, she has served as Técnico Ombudsman. She previously coordinated the Master in Biological Engineering and contributed to the MIT-Portugal PhD Program. Her research focuses on developing high-performance separation processes for biopharmaceutical purification, especially antibody purification and microscale “Lab-on-a-Chip” systems. She has participated in multiple European projects, chairs the Downstream Processing Section of ESBES, and serves on scientific and organising committees of several international conferences. She is President of the Portuguese Society for Biotechnology and Editor of Separation and Purification Technology. She has supervised over 70 graduate theses and authored more than 200 publications.
              </p>

              <div className="mt-4">
                <Button
                  variant="bpp-pink"
                  size="md"
                  href="/files/x.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download Abstract (.pdf)
                </Button>
              </div>
            </>
          )}
          
          {activeModal === "modalD" && (
            <>
              <p>
                Anna Sandak is an associate professor at the University of Primorska, where she leads the Materials Group at the InnoRenew CoE Department. Her academic background bridges biology and wood science. Before moving to Slovenia, she worked in Italy at the National Research Council (CNR-IVALSA). In her 18-year scientific career, she has contributed to over 30 research projects, leading 12 of them, and supervising 4 MSCA postdoctoral researchers. In 2022, Dr Sandak was awarded the ERC consolidator grant for the project ARCHI-SKIN, which develops a living coatings system based on fungal biofilm. Her study on probiotic architecture continues within the REMEDY project, recently awarded under the European Innovation Council Pathfinder call, which she coordinates. She represents research and academia on the European Commission’s Technology Council for Advanced Materials and serves on the Management Board of the New European Bauhaus Academy Pioneer Hub, the steering committee of the EIC’s Engineered Living Materials portfolio, and the Research and Innovation working group of WoodPop. Her research focuses on the intersection of biotech and advanced materials, concentrating on exploiting renewable materials and engineered living systems to revolutionize the construction industry. By integrating biotechnology with traditional building practices, she aims to create resilient, eco-friendly structures that adapt and evolve with their environments, setting new standards for sustainability in the built environment.
              </p>

              <div className="mt-4">
                <Button
                  variant="bpp-pink"
                  size="md"
                  href="/files/Sandak_Anna_keynote.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download Abstract (.pdf)
                </Button>
              </div>
            </>
          )}
          
          
          {activeModal === "modalE" && (
            <>
              <p>
                Born in Našice in 1982; enrolled in a Postgraduate University Study Program of Food Engineering in 2008, and in 2011 she received her PhD. Professional activity: a full professor at Faculty of Food technology Osijek at the Department of Process Engineering. From 2018 to 2021 she was a Vice-dean for Science an from 2021 to 2025 Vice-Dean for Marketing and Business Cooperation. Today she is a dean of the Faculty of gFood Technology. Research work: involved in realization of many scientific and professional projects. She was a project leader in ten projects mainly related to the extraction of bioactive compounds. She designed and constructed the first pilot supercritical CO2 extraction device in the Republic of Croatia. Supervised: 7 PhD theses. Bibliography: author/co-author of more than 200 articles in international peer-reviewed journals and 15 book chapters. Cumulative h-index = 52. Awards:  Croatian Women of Influence 2025 (science and technology); National Science Award for 2018 for promotion of the science (Republic Croatia); Award of the Croatian Academy of Engineering Rikard Podhorsky; National Science Award for 2016 in the field of Biotechnical science; Danubius Young Scientist Award 2015 for Croatia; Award of the Croatian Academy of Engineering for young scientist “Vera Johanides” in 2013, Annual Science Award for the year 2012 from Osijek-Baranja County, National Science Award for 2011 for young scientist Additionally: She achieved a good communication and professional skills during her several months stay at USA and in different European countries through mobility exchange programs. She has excellent cooperation with the industry where participated in the development of new products. She has promoted science and the profession many times through different media as well as through popular scientific and professional lectures at various events. She is a member of the Croatian Society of Chemical Engineering, European Hygienic Engineering and Design Group; TehnOS association. She is elected as the top 2% of scientist by Stanford University and Elsevier last four years. She is now Editor-in-Chief of Croatian Journal of Food Science and Technology.
              </p>

              <div className="mt-4">
                <Button
                  variant="bpp-pink"
                  size="md"
                  href="/files/Joki__Stela_keynote.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download Abstract (.pdf)
                </Button>
              </div>
            </>
          )}
          
          {activeModal === "modalF" && (
            <>
              <p>
                Prof. Dr. H. Mecit Öztop is a faculty member in the Department of Food Engineering at Middle East Technical University and currently serves as the Research Coordinator of the university. His research focuses on food processing, food structure–function relationships, alternative proteins, aerogels, rheology, MRI and NMR applications in food systems, and sustainable food technologies. He has coordinated and participated in numerous national and international projects funded by Horizon Europe, PRIMA, COST, and TÜBİTAK, including MSCA Doctoral Networks and Staff Exchange projects. Prof. Öztop has extensive experience in interdisciplinary research, innovation management, and international collaboration, particularly in the areas of sustainable food systems, valorisation of agro-industrial side streams, and advanced characterization techniques. He has supervised more than 50 graduate theses and leads an active research group at METU working on innovative food processing and material science applications. Alongside his academic activities, he contributes to research strategy, capacity building, and internationalization efforts at institutional and European levels.
              </p>

              <div className="mt-4">
                <Button
                  variant="bpp-pink"
                  size="md"
                  href="/files/Oztop_Mecit_keynote.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download Abstract (.pdf)
                </Button>
              </div>
            </>
          )}

          {activeModal === "modalG" && (
            <>
              <p>
                Dr. Barry Hardy is the Chief Executive Officer (CEO) at Edelweiss Connect where he is leading its team, supporting the development of new integrating solutions in industrial product design and safety assessment and the translation of research methods to industrial practice. Example recent commercial developments include the creation of the SaferWorldbyDesign platform, and the development of the SaferSkin and EdelweissData products. He is currently leading the development of risk assessment knowledge infrastructure and solutions, including new approach methods, SaferbyDesign, sustainability and next generation risk assessment solutions. He coordinated the OpenTox project in predictive toxicology and is currently President of the OpenTox Association, founded in 2015 as an international non-profit organisation promoting an open knowledge community approach to new methods in predictive toxicology and the 3Rs principles of the refinement, reduction and replacement of animal experiments. Previously, he led the infrastructure development for the IMI EBiSC stem cell banking project, the eNanoMapper project developing solutions supporting nanotechnology safety assessment, OpenRiskNet infrastructure development supporting risk assessment, and knowledge infrastructure development for ACEnano, NanoCommons and EU-ToxRisk. Dr. Hardy obtained his Ph.D. in 1990 from Syracuse University working in computational science. He was a National Research Fellow at the FDA Center for Biologics and Evaluation, a Hitchings-Elion Fellow at Oxford University and CEO of Virtual Environments International. He was a pioneer in the 1990s in the development of Web technology applied to virtual scientific communities and conferences. He has developed technology solutions for internet-based communications, tutor-supported e-learning, laboratory automation systems, and computational science and informatics. In recent years he has also been active in the field of knowledge management as applied to supporting innovation, communities of practice, and collaboration, with a particular focus on developing new evidence-based methods in predictive toxicology and safety assessment, including development of Integrated Approaches to Testing and Assessment (IATAs) and their application to industrial and regulatory practice.
              </p>

              <div className="mt-4">
                <Button
                  variant="bpp-pink"
                  size="md"
                  href="/files/Hardy_Barry_plenary.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download Abstract (.pdf)
                </Button>
              </div>
            </>
          )}
          
        </Modal.Body>

        <Modal.Footer>
          <Button variant="bpp-pink" size="lg" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
}
 